var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "47px",
    viewBox: "0 0 45 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "9e-06 0.018432 44.06913 0.018432 44.06913 45.269982 9e-06 45.269982"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7.-How-Hana-Works--UI",
    transform: "translate(-331.000000, -533.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(331.000000, 533.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 0.071640)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.034619,43.672122 C10.737729,43.672122 1.597869,34.260912 1.597869,22.644342 C1.597869,11.027862 10.737729,1.616292 22.034619,1.616292 C33.331509,1.616292 42.471279,11.027862 42.471279,22.644342 C42.471279,34.260912 33.331509,43.672122 22.034619,43.672122 M22.034619,0.018432 C9.874809,0.018432 9e-06,10.164942 9e-06,22.644342 C9e-06,35.123832 9.874809,45.269982 22.034619,45.269982 C34.194339,45.269982 44.069139,35.123832 44.069139,22.644342 C44.069139,10.164942 34.194339,0.018432 22.034619,0.018432",
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.471297,22.716018 C42.471297,34.332498 33.331527,43.743798 22.034637,43.743798 C10.737657,43.743798 1.597887,34.332498 1.597887,22.716018 C1.597887,11.099538 10.737657,1.687878 22.034637,1.687878 C33.331527,1.687878 42.471297,11.099538 42.471297,22.716018",
    id: "Fill-4",
    fill: "#F0CED5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.032226,18.514143 C21.032226,17.521803 21.632976,15.825573 22.495086,15.825573 C23.147406,15.825573 24.296616,16.268733 24.296616,16.920963 C24.296616,17.913393 23.670126,19.611063 22.834476,19.611063 C22.181526,19.611063 21.032226,19.167993 21.032226,18.514143 M19.779246,21.335373 C19.883736,20.968623 20.248956,20.786103 20.640546,20.786103 C20.954196,20.786103 22.729896,21.727053 22.729896,22.223223 C22.729896,22.822443 20.614806,28.698993 20.614806,30.526263 C20.614806,30.866373 21.032226,31.258053 21.293586,31.258053 C22.051116,31.258053 23.460966,29.246643 24.792786,26.896743 C24.792786,26.896743 25.001856,26.427033 25.341336,26.427033 C25.680636,26.427033 26.229186,26.845173 26.229186,27.157293 C26.229186,27.470943 25.863336,28.071693 25.863336,28.071693 C24.453486,30.683853 22.886766,33.058683 21.006486,33.058683 C19.831446,33.058683 17.481546,31.963383 17.481546,30.786813 C17.481546,29.560293 19.335366,22.953483 19.779246,21.335373",
    id: "Fill-6",
    fill: "#FFFFFF"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoAlt);
export default __webpack_public_path__ + "static/media/infoAlt.e659c2dc.svg";
export { ForwardRef as ReactComponent };